import { SectionHeader } from "./SectionHeader";
import type { Theme } from "./theme";

const TRADITIONAL = [
  "external dependency for complex roles",
  "inconsistent assessment",
  "limited internal learning",
  "decisions driven by urgency",
];

const RARION = [
  "structured role definition",
  "consistent, shared evaluation",
  "aligned stakeholder input",
  "repeatable, scalable hiring capability",
];

export function CapabilityShift({ theme }: { theme: Theme }) {
  return (
    <section style={{ padding: "120px 0", borderTop: `1px solid ${theme.border}` }}>
      <SectionHeader
        theme={theme}
        kicker="Capability shift"
        title="From reliance on agencies to internal capability."
      />
      <div
        style={{
          maxWidth: 1200,
          margin: "0 auto",
          padding: "0 40px",
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 24,
        }}
      >
        <div
          style={{
            padding: 32,
            border: `1px solid ${theme.border}`,
            borderRadius: theme.radius * 1.5,
            background: theme.bg,
          }}
        >
          <div
            style={{
              fontSize: 12,
              letterSpacing: 0.5,
              textTransform: "uppercase",
              color: theme.fgMute,
              marginBottom: 16,
            }}
          >
            Traditional approach
          </div>
          <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
            {TRADITIONAL.map((t) => (
              <li
                key={t}
                style={{
                  padding: "12px 0",
                  borderBottom: `1px solid ${theme.border}`,
                  display: "flex",
                  gap: 12,
                  alignItems: "center",
                  fontSize: 15,
                  color: theme.fgMute,
                }}
              >
                <span style={{ width: 14, height: 1, background: theme.fgMute }} />
                {t}
              </li>
            ))}
          </ul>
        </div>
        <div
          style={{
            padding: 32,
            border: `1.5px solid ${theme.accent}`,
            borderRadius: theme.radius * 1.5,
            background: theme.accentSoft,
            position: "relative",
          }}
        >
          <div
            style={{
              fontSize: 12,
              letterSpacing: 0.5,
              textTransform: "uppercase",
              color: theme.accentFg,
              marginBottom: 16,
            }}
          >
            With Rarion
          </div>
          <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
            {RARION.map((t) => (
              <li
                key={t}
                style={{
                  padding: "12px 0",
                  borderBottom: `1px solid ${theme.accentBorder}`,
                  display: "flex",
                  gap: 12,
                  alignItems: "center",
                  fontSize: 15,
                  color: theme.fg,
                  fontWeight: 500,
                }}
              >
                <svg
                  aria-hidden="true"
                  focusable="false"
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  stroke={theme.accentFg}
                  strokeWidth="2"
                  strokeLinecap="round"
                >
                  <path d="M3 7l3 3 6-6" />
                </svg>
                {t}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
